// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608051636/js/" + chunkId + "." + {"44":"2f3c4cd1","225":"e2a2ec8f","481":"f2495bb7","486":"c890a6d4","770":"6db8b88a"}[chunkId] + ".0.4525755448451614.chunk.js";
};